import { styled } from '@mui/material/styles';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export const PaperStyled = styled(Paper, {
  name: 'RegulationsTablePaperStyled',
})(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(1),
}));

export const TableStyled = styled(Table, {
  name: 'RegulationsTableStyled',
})(({ theme }) => ({
  tableLayout: 'fixed',
  '& .MuiTableCell-root': {
    padding: theme.spacing(1, 2),
  },
}));

export const TableHeadStyled = styled(TableHead, {
  name: 'RegulationsTableHeadStyled',
})(() => ({
  textTransform: 'none',
}));

export const TableBodyStyled = styled(TableBody, {
  name: 'RegulationsTableBodyStyled',
})(() => ({}));

export const TableRowStyled = styled(TableRow, {
  name: 'RegulationsTableRowStyled',
})(() => ({}));

export const TableCellStyled = styled(TableCell, {
  name: 'RegulationsTableCellStyled',
})(() => ({}));

export { DeleteIcon, AddIcon, ExpandMoreIcon, ExpandLessIcon };
